export type IWorkTypeState = {
    id: number;
    name: string;
}

export enum IWorkTypeActionTypes {
    FETCH_WORK_TYPES_REQUEST = 'FETCH_WORK_TYPES_REQUEST',
    FETCH_WORK_TYPES_SUCCESS = 'FETCH_WORK_TYPES_SUCCESS',
    FETCH_WORK_TYPES_FAILURE = 'FETCH_WORK_TYPES_FAILURE',

}

export type IWorkTypeActionCreator = {
    type: string;
    payload: IWorkTypeState;
  };
